import { useState, useContext } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UsergroupAddOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu } from "antd";
import { AuthTokenContext, userDataContext } from "../context/tokenContext";
import { useNavigate, Outlet } from "react-router-dom";
import { logout } from "../services/authenticationService";
import { showErrorToast } from "../ToastHelper";
const { Header, Content, Sider } = Layout;

function Home() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [token, setToken] = useContext(AuthTokenContext);
  const [userData, setUserData] = useContext(userDataContext);

  async function logoutService() {
    try {
      await logout(token);
      navigate("/");
      setToken("");
      // sea("");
    } catch (error) {
      showErrorToast(error.message);
    }
  }
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        style={{ background: "#334b5e" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        // collapsedWidth="0"
        onBreakpoint={(broken) => {}}
      >
        <div className="demo-logo-vertical">
          <Menu
            style={{
              // height: "100vh",
              background: "#334b5e",
              paddingTop: "10px",
            }}
            onClick={(item) => {
              item.key === "1"
                ? navigate("/home/userManagement")
                : item.key === "2"
                ? navigate("/home/changePassword")
                : logoutService();
            }}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={userData.userStatus === "ACT" ? ["1"] : ["2"]}
            items={[
              {
                key: "1",
                icon: <UsergroupAddOutlined />,
                label: "Users Management",
                disabled: userData.userStatus === "INIT" ? true : false,
              },
              {
                key: "2",
                icon: <LockOutlined />,
                label: "Change Password",
              },
              {
                key: "3",
                icon: <LogoutOutlined />,
                label: "Logout",
              },
            ]}
          />
        </div>
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: "#334b5e" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              color: "white",
            }}
          />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default Home;
